"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ContactTitle = exports.OptInsScope = exports.AddressType = exports.OptInsChannel = void 0;
var OptInsChannel;
(function (OptInsChannel) {
    OptInsChannel["EMAIL"] = "email";
    OptInsChannel["PHONE"] = "phone";
    OptInsChannel["SNAILMAIL"] = "snailmail";
    OptInsChannel["SMS"] = "sms";
})(OptInsChannel = exports.OptInsChannel || (exports.OptInsChannel = {}));
var AddressType;
(function (AddressType) {
    AddressType["INVOICE"] = "invoice";
    AddressType["DELIVERY"] = "delivery";
})(AddressType = exports.AddressType || (exports.AddressType = {}));
var OptInsScope;
(function (OptInsScope) {
    OptInsScope["ON_DEMAND"] = "on_demand";
    OptInsScope["HSV_GROUP"] = "hsv_group";
})(OptInsScope = exports.OptInsScope || (exports.OptInsScope = {}));
var ContactTitle;
(function (ContactTitle) {
    ContactTitle["Mr"] = "M.";
    ContactTitle["Ms"] = "Mme";
})(ContactTitle = exports.ContactTitle || (exports.ContactTitle = {}));
//# sourceMappingURL=customer.js.map